<script>
  import LinkButton from './LinkButton.svelte';
  import QuoteButton from './QuoteButton.svelte';

  export let path;
</script>

<div class="buttons fullscreen-button">
  <LinkButton to={path} label="start my design" type="orange" fontSize="large" ripple="ripple" />
  <QuoteButton alternate marginReset />
</div>

<style>
  .buttons {
    justify-content: center;
    gap: 2rem;
  }
  .fullscreen-button {
    display: flex;
    justify-content: center;
    padding-top: 5rem;
    padding-bottom: 5rem;
    background-color: #f7f7f7;
  }
</style>
